import React from 'react'
import styled from 'styled-components'

const StyledFeatureText = styled.div`
  margin: 5rem auto 10rem;
  border-left: 6px solid #4f4f4f;
  /* border-right: 2px solid #4f4f4f;
  border-top: 2px solid #4f4f4f;
  border-bottom: 2px solid #4f4f4f; */
  /* border-radius: 100px; */
  /* padding-left: 50px; */
  padding: 30px 70px;
  max-width: 70%;
  /* margin-bottom: -40px; */
  background-color: rgba(255, 255, 255, 0.5);
  @media (max-width: 768px) {
    max-width: 100%;
    margin: 3rem auto 10rem;
  }
`

const TopLabel = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #aaaaaa;
  text-transform: uppercase;
  transform: translateY(-6px);
`

const Quote = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  font-weight: 500;
  font-style: italic;
  font-size: 24px;
  line-height: 35px;
  color: #4f4f4f;
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 30px;
  }
`

const FeatureText = ({ quote, eyeBrow }) => (
  <StyledFeatureText>
    <TopLabel>{eyeBrow}</TopLabel>
    <Quote>{quote}</Quote>
  </StyledFeatureText>
)

export default FeatureText
